import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerDescription = styled.div`
  display: flex;
  max-width: 100%;
  align-items: center;
`;

export const ContainerChildren = styled.div`
  display: flex;
`;

export const ContainerSearch = styled.div`
  width: 100%;
  max-width: 700px;
`;
